import { CropType, Safra } from '../types';

export const SAFRA_OPTIONS: { value: Safra; label: string }[] = [
  { value: '22/23', label: 'Safra 22/23' },
  { value: '23/24', label: 'Safra 23/24' },
  { value: '24/25', label: 'Safra 24/25' },
  { value: '25/26', label: 'Safra 25/26' },
  { value: '26/27', label: 'Safra 26/27' },
];

export const CROP_OPTIONS: { value: CropType; label: string }[] = [
  { value: 'soja', label: 'Soja' },
  { value: 'milho_safra', label: 'Milho Safra' },
  { value: 'milho_safrinha', label: 'Milho Safrinha' },
  { value: 'algodao', label: 'Algodão' },
  { value: 'algodao_safrinha', label: 'Algodão Safrinha' },
  { value: 'milheto', label: 'Milheto' },
  { value: 'sorgo', label: 'Sorgo' },
  { value: 'feijao', label: 'Feijão' },
  { value: 'arroz', label: 'Arroz' },
  { value: 'outras', label: 'Outras' },
];

export const SAFRA_OPTIONS_SHORT: { value: Safra; label: string }[] = [
  { value: '22/23', label: '22/23' },
  { value: '23/24', label: '23/24' },
  { value: '24/25', label: '24/25' },
  { value: '25/26', label: '25/26' },
  { value: '26/27', label: '26/27' },
];

export const MARITAL_STATUS_OPTIONS = [
  { value: 'solteiro', label: 'Solteiro(a)' },
  { value: 'casado', label: 'Casado(a)' },
  { value: 'uniao_estavel', label: 'União Estável' },
  { value: 'divorciado', label: 'Divorciado(a)' },
  { value: 'viuvo', label: 'Viúvo(a)' },
];

export const INVESTMENT_SAFRA_OPTIONS: { value: Safra; label: string }[] = [
  { value: '25/26', label: 'Safra 25/26' },
  { value: '26/27', label: 'Safra 26/27' },
];

export const CURRENCY_OPTIONS = [
  { value: 'BRL', label: 'BRL' },
  { value: 'USD', label: 'USD' },
];
